import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export { DropdownListWrapper } from 'containers/SubSidebar/shared/GroupedModelDropdown/styled'

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SectionHeaderWrapper = styled.div`
  padding: 4px 8px;
`

export const SectionDivider = styled.hr`
  margin-bottom: 10px;
  border: 0;
  border-top: 1px solid ${COLORS.borderColor};
`
